import { useState, useRef } from "react";
import {
  CarouselContainer,
  ScrollWrapper,
  Card,
  ExpandedContent,
  PlayIcon,
} from "./TrackCarouselStyles";
import { FaPlay, FaStepBackward, FaStepForward } from "react-icons/fa";
import { MultiLinkItem } from "../../types/componentsConstructors";

import cover1 from "../../img/logged/cover1.png";
import cover2 from "../../img/logged/cover2.png";
import cover3 from "../../img/logged/cover3.png";

const mockTracks: MultiLinkItem[] = [
  { name: "Neon Pulse", url: "#", imageUrl: cover1 },
  { name: "Echoes of Midnight", url: "#", imageUrl: cover2 },
  { name: "Gravity Flow", url: "#", imageUrl: cover3 },
];

interface TrackCarouselProps {
  tracks?: MultiLinkItem[];
}

const TrackCarousel = ({ tracks = mockTracks }: TrackCarouselProps) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleCardClick = (index: number) => {
    setActiveIndex((prev) => (prev === index ? null : index));

    const container = scrollRef.current;
    const card = container?.children[index] as HTMLElement;

    if (container && card) {
      const containerRect = container.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();

      const scrollOffset =
        card.offsetLeft - container.offsetWidth / 2 + card.offsetWidth / 2;

      container.scrollTo({
        left: scrollOffset,
        behavior: "smooth",
      });
    }
  };

  return (
    <CarouselContainer>
      <ScrollWrapper ref={scrollRef}>
        {tracks.map((track, index) => {
          const isActive = activeIndex === index;

          return (
            <Card
              key={index}
              $active={isActive}
              onClick={() => handleCardClick(index)}
              role="button"
              aria-pressed={isActive}
              title={isActive ? "Abrir controles" : "Tocar"}
            >
              <img src={track.imageUrl} alt={track.name} />

              {!isActive && <PlayIcon aria-hidden />}

              {isActive && (
                <ExpandedContent>
                  <p>{track.name}</p>
                  <div className="controls">
                    <FaStepBackward />
                    <FaPlay />
                    <FaStepForward />
                  </div>
                </ExpandedContent>
              )}
            </Card>
          );
        })}
      </ScrollWrapper>
    </CarouselContainer>
  );
};

export default TrackCarousel;
